import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";
import { find } from "lodash-es";

const getRequestState = (state: RootState) => state.request;

export const getIsRequestPendingByResource = createSelector(
  [getRequestState, (_state: RootState, resourceName: string) => resourceName],
  (requestState, resourceName) => {
    return !!find(requestState.requests, resource => resource === resourceName);
  }
);
